import { api } from "@/api/client";

// Mirrors BillReminderSerializer.
export interface BillReminder {
  id: number;
  triage_decision_id: number;
  remind_at: string;
  note: string | null;
  due: boolean;
  emailed_at: string | null;
  path: string;
  bill: {
    title: string;
    subject: string | null;
    from_name: string | null;
    vendor_name: string | null;
    amount: number | null;
    status_label: string;
  };
}

export interface BillReminderList {
  due_count: number;
  reminders: BillReminder[]; // due first, then upcoming
}

export const BILL_REMINDERS_KEY = ["bill_reminders"] as const;

export async function fetchBillReminders(): Promise<BillReminderList> {
  const { data } = await api.get<BillReminderList>("/bill_reminders");
  return data;
}

// Replaces your open reminder on that queue item if there is one.
export async function saveBillReminder(triageDecisionId: number, remindAt: Date, note?: string): Promise<BillReminder> {
  const { data } = await api.post<BillReminder>("/bill_reminders", {
    reminder: { triage_decision_id: triageDecisionId, remind_at: remindAt.toISOString(), note: note || null },
  });
  return data;
}

export async function snoozeBillReminder(id: number, remindAt: Date): Promise<BillReminder> {
  const { data } = await api.patch<BillReminder>(`/bill_reminders/${id}`, {
    reminder: { remind_at: remindAt.toISOString() },
  });
  return data;
}

export async function dismissBillReminder(id: number): Promise<void> {
  await api.delete(`/bill_reminders/${id}`);
}

// Preset times, in the browser's local time.
export function inHours(hours: number): Date {
  return new Date(Date.now() + hours * 3_600_000);
}

export function tomorrowAt(hour: number): Date {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  d.setHours(hour, 0, 0, 0);
  return d;
}

export function nextMondayAt(hour: number): Date {
  const d = new Date();
  d.setDate(d.getDate() + (((8 - d.getDay()) % 7) || 7));
  d.setHours(hour, 0, 0, 0);
  return d;
}

export function formatRemindAt(iso: string): string {
  return new Date(iso).toLocaleString(undefined, { weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}
